"use client"
import { ButtonFluxi } from "../common/Buttons/ButtonFluxi/ButtonFluxi"
import { Button } from "../ui/button"

interface PlanChangeModalProps {
  isOpen: boolean
  onClose: () => void
  onUpgrade: () => void
  onCancel: () => void
}

export function PlanChangeModal({ isOpen, onClose, onUpgrade, onCancel }: PlanChangeModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-lg w-full max-w-md mx-4 p-6">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-xl font-bold"
        >
          ×
        </button>

        {/* Content */}
        <div className="space-y-6">
          <h2 className="text-xl font-semibold text-center text-gray-900">Cambiar mi plan</h2>

          <p className="text-gray-600 text-center">¿Qué te gustaría hacer con tu plan actual?</p>

          <div className="flex items-center justify-center gap-2">
            <div className="flex items-center justify-center gap-2 w-full">
              <ButtonFluxi style={{ fontSize: "16px", paddingTop: "10px", paddingBottom: "10px", minWidth: "100%", maxHeight: "40px", width: "100%" }} onClick={onUpgrade}>
                Mejorar mi plan
              </ButtonFluxi>
            </div>
            <Button
              onClick={onCancel}
              className="w-full border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 font-medium py-3 rounded-lg"
            >
              Cancelar mi plan
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
